import React from "react";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import SportsEsportsRoundedIcon from "@mui/icons-material/SportsEsportsRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import SelfImprovementRoundedIcon from "@mui/icons-material/SelfImprovementRounded";

const modes = [
  {
    name: "Classic",
    description: "Your familiar task and timer experience.",
    icon: SelfImprovementRoundedIcon,
    available: true,
  },
  {
    name: "Focus Sprint",
    description: "Short, structured sessions for high-energy work.",
    icon: BoltRoundedIcon,
    available: false,
  },
  {
    name: "Battle Ground",
    description: "A challenge-based mode with competitive progress.",
    icon: SportsEsportsRoundedIcon,
    available: false,
  },
  {
    name: "Team Quest",
    description: "Complete shared routines with friends or teammates.",
    icon: GroupsRoundedIcon,
    available: false,
  },
];

const PlayModeSelector = () => {
  return (
    <section className="play-mode">
      <header className="play-mode-header">
        <span className="play-mode-header-icon">
          <SportsEsportsRoundedIcon />
        </span>
        <div>
          <h2>Pick a Mode</h2>
          <p>Modes change how your tasks and focus sessions feel.</p>
        </div>
      </header>

      <div className="play-mode-list">
        {modes.map((mode) => {
          const ModeIcon = mode.icon;

          return (
            <button
              type="button"
              key={mode.name}
              className={`play-mode-row ${
                mode.available ? "is-active" : "is-locked"
              }`}
              disabled={!mode.available}
              aria-pressed={mode.available}
            >
              <span className="play-mode-row-icon">
                <ModeIcon />
              </span>
              <span className="play-mode-row-copy">
                <strong>{mode.name}</strong>
                <small>{mode.description}</small>
              </span>
              <span
                className={`play-mode-status ${
                  mode.available ? "is-active" : ""
                }`}
              >
                {mode.available ? (
                  <>
                    <CheckRoundedIcon />
                    Active
                  </>
                ) : (
                  <>
                    <LockRoundedIcon />
                    Coming soon
                  </>
                )}
              </span>
            </button>
          );
        })}
      </div>

      <p className="play-mode-note">
        New modes will appear here as they become available.
      </p>
    </section>
  );
};

export default PlayModeSelector;
